import { FunctionComponent } from 'react';

import { IndexLevel, Props } from './index';
import StyledComponent from './styles';

const SectionArticlesArticleIndex: FunctionComponent<Props> = ({ indexStructure }) => (
    <StyledComponent className="section-articles-article-index">
        <div className="index-level index-level-1">
            {Object.keys(indexStructure).map(indexL1Key => {
                const indexL1: IndexLevel = indexStructure[indexL1Key];

                return (
                    <div
                        className="index-element index-element-level-1"
                        key={indexL1.key}
                    >
                        <a
                            href={`#indexl1-${indexL1.order}`}
                            className="index-text"
                        >
                            <span className="dot" />
                            {/*<span>*/}
                            {/*    {`${indexL1.order}.`}*/}
                            {/*</span>*/}
                            {indexL1.text}
                        </a>

                        {Object.keys(indexL1.elements).length > 0 && (
                            <div className="index-level index-level-2">
                                {Object.keys(indexL1.elements).map(indexL2Key => {
                                    const indexL2: IndexLevel = indexL1.elements[indexL2Key];

                                    return (
                                        <div
                                            className="index-element index-element-level-2"
                                            key={indexL2.key}
                                        >
                                            <a
                                                href={`#indexl2-${indexL2.order}`}
                                                className="index-text"
                                            >
                                                <span className="dot" />
                                                {indexL2.text}
                                            </a>

                                            {Object.keys(indexL2.elements).length > 0 && (
                                                <div className="index-level index-level-3">
                                                    {Object.keys(indexL2.elements).map(indexL3Key => {
                                                        const indexL3: IndexLevel = indexL2.elements[indexL3Key];

                                                        return (
                                                            <div
                                                                className="index-element index-element-level-3"
                                                                key={indexL3.key}
                                                            >
                                                                <a
                                                                    href={`#indexl2-${indexL3.order}`}
                                                                    className="index-text"
                                                                >
                                                                    <span className="dot" />
                                                                    {indexL3.text}
                                                                </a>
                                                            </div>
                                                        );
                                                    })}
                                                </div>
                                            )}
                                        </div>
                                    );
                                })}
                            </div>
                        )}
                    </div>
                );
            })}
        </div>
    </StyledComponent>
);

export default SectionArticlesArticleIndex;
